var _axios$interceptors$r, _axios$interceptors$r2, _axios$interceptors$r3;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import originAxios from 'axios';
import { injectGlobalInterceptors } from "./interceptors/global-interceptors";
import * as ERRORS from "./errors";
import { injectBusinessException, injectMtopException } from "./interceptors/exception";
import { mtopInterceptor } from "./interceptors/mtop";
import { requestSecurity } from "./interceptors/security";
import { requestParams } from "./interceptors/url-params";
import { injectException } from "./interceptors/exception";
export { injectException } from "./interceptors/exception";
export * from "./errors";
export * from "./types";
var axios = originAxios.create({
  timeout: 30 * 1000
});
axios.ERRORS = ERRORS;
axios.defaults.xsrfCookieName = 'c_csrf';
(_axios$interceptors$r = axios.interceptors.request).use.apply(_axios$interceptors$r, _toConsumableArray(requestParams));
(_axios$interceptors$r2 = axios.interceptors.request).use.apply(_axios$interceptors$r2, _toConsumableArray(requestSecurity));
(_axios$interceptors$r3 = axios.interceptors.request).use.apply(_axios$interceptors$r3, _toConsumableArray(mtopInterceptor));
axios.interceptException = injectException.bind(null, axios);
injectBusinessException(axios);
injectMtopException(axios);
injectGlobalInterceptors(axios);
export default axios;